<template>
  <template v-if="transition === 'confirm'">
    <transition name="confirm-fade">
      <div
        v-if="overlayShow"
        class="modal-overlay"
        :class="{ flex: !relativePosition, 'top-zero': topZero }"
        @click="close"
      >
        <div class="modal-content" :class="{ show: contentShow }" @click.stop>
          <slot></slot>
        </div>
      </div>
    </transition>
  </template>
  <template v-else>
    <transition name="fade">
      <div
        v-if="overlayShow"
        class="modal-overlay"
        :class="{ flex: !relativePosition, 'top-zero': topZero }"
        @click="close"
      >
        <div class="modal-content" :class="{ show: contentShow }" @click.stop>
          <slot></slot>
        </div>
      </div>
    </transition>
  </template>
</template>

<script setup lang="ts">
  import { watch, ref } from 'vue'

  const props = defineProps<{
    show: boolean
    relativePosition?: boolean
    topZero?: boolean
    transition?: 'confirm' | undefined

    // 부모 컴포넌트에서 클릭 이벤트 제어 여부
    controlParentClick?: boolean
  }>()
  const emit = defineEmits(['update:show'])

  const overlayShow = ref<boolean>(false)
  const contentShow = ref<boolean>(false)

  function delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  function close(): void {
    if (props.controlParentClick) {
      return
    }
    emit('update:show', false)
  }

  async function openTrigger(): Promise<void> {
    overlayShow.value = true
    await delay(100)
    contentShow.value = true
  }

  async function closeTrigger(): Promise<void> {
    contentShow.value = false
    await delay(200)
    overlayShow.value = false
  }

  watch(
    () => props.show,
    async show => {
      if (show) await openTrigger()
      else await closeTrigger()
    },
    { immediate: true },
  )
</script>

<style lang="scss" scoped>
  .modal-overlay {
    position: fixed;
    top: -65px;
    left: 0;
    width: 100vw;
    height: calc(100vh + 65px);
    background: rgba(0, 0, 0, 0.15);
    justify-content: center;
    align-items: center;
    z-index: 999999;
    &.flex {
      display: flex;
    }
    .modal-content {
      transform: translateY(50px);
      opacity: 0;
      transition: 0.3s ease;
      &.show {
        transform: translateY(0px);
        opacity: 1;
      }
    }
  }

  .top-zero {
    top: 0;
    height: 100vh;

    .modal-content {
      max-height: 100%;
    }
  }

  .top-zero.flex {
    align-items: stretch;

    .modal-content {
      display: flex;
      align-items: center;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.28s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-to,
  .fade-leave-from {
    opacity: 1;
  }

  .confirm-fade-enter-active,
  .confirm-fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .confirm-fade-enter-active .modal-content,
  .confirm-fade-leave-active .modal-content {
    transition: all 0.2s ease;
  }

  .confirm-fade-enter-from,
  .confirm-fade-leave-to {
    opacity: 0;
  }
  .confirm-fade-enter-from .modal-content,
  .confirm-fade-leave-to .modal-content {
    transform: translateY(10px);
    opacity: 0;
  }

  .confirm-fade-enter-to,
  .confirm-fade-leave-from {
    opacity: 1;
  }
</style>
